const Download = ({ handleOnClick, downloading }) => {
  return (
    <>
      {downloading && <span>Downloading ...</span>}

      {!downloading && (
        <div>
          <button className="download-btn" onClick={handleOnClick}>Download all</button>
        </div>
      )}
    </>
  );
};
export default Download;
